import { z } from 'zod';
/** Server-assigned identifiers. UUIDs everywhere so client-generated ids can be accepted as-is. */
export const idSchema = z.uuid();
/** Calendar date without time, `YYYY-MM-DD`. All week maths works on this shape. */
export const isoDateSchema = z.iso.date();
/** Timestamp with offset, as produced by `Date#toISOString()`. */
export const isoDateTimeSchema = z.iso.datetime({ offset: true });
/** Variety codes are short uppercase codes such as EGD, GDL, GRS. */
export const varietyCodeSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z0-9]{2,5}$/, 'Variety code must be 2 to 5 letters or digits.');
/** Week number within the calendar year, 1 to 53. */
export const weekNumberSchema = z.number().int().min(1).max(53);
/** Season label as shown to growers, e.g. `2026/2027`. */
export const seasonLabelSchema = z
    .string()
    .regex(/^\d{4}\/\d{4}$/, 'Season must look like 2026/2027.');
/** A count of bins. Whole numbers only, never negative. */
export const binCountSchema = z.number().int().min(0).max(100_000);
/** Six values, Monday to Saturday. Index 0 is Monday. */
export const weekBinsSchema = z.tuple([
    binCountSchema,
    binCountSchema,
    binCountSchema,
    binCountSchema,
    binCountSchema,
    binCountSchema,
]);
export const DAYS_PER_ESTIMATE = 6;
//# sourceMappingURL=common.js.map